/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Open_WorkflowInputs */

const cs_settings_automation_open_workflow = /** @type {(inputs: Settings_Automation_Open_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít workflow`)
};

const en_settings_automation_open_workflow = /** @type {(inputs: Settings_Automation_Open_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open workflow`)
};

/**
* | output |
* | --- |
* | "Open workflow" |
*
* @param {Settings_Automation_Open_WorkflowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_open_workflow = /** @type {((inputs?: Settings_Automation_Open_WorkflowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Open_WorkflowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_open_workflow(inputs)
	return cs_settings_automation_open_workflow(inputs)
});